/**
 * Import and instantiate front end modules
 */

import { EdModal } from './modules/ed-modal';
import { FilterCheckboxes } from './modules/filter-checkboxes';
import { Navigation } from './modules/navigation';
import { FilterArchive } from './modules/filter-archive';
import { Search } from './modules/search';
import { EdIntersectionObserver } from './modules/ed-intersection-observer';
import { FilterModal } from './modules/filter-modal';
import { VideoModal } from './modules/video-modal';
import { LLVideo } from './modules/lazy-load-video.js';
import { VideoPlayer } from './modules/video';
import { Agents } from './modules/agents';

import svgxhr from "webpack-svgstore/dist/helpers/svgxhr";

svgxhr("/wp-content/themes/arc/dist/svg/svg-sprites.svg");


// Primary nav
(() => {
    const navigationEl = document.getElementById('primary-open-menu');
    if (navigationEl instanceof window.HTMLElement) {
        new Navigation(navigationEl);
    }
})();

// Filter Checkboxes
(() => {
    const rootClass = 'filter-checkboxes';
    const blockEls = document.querySelectorAll(`.${rootClass}`);
    blockEls.forEach((blockEl) => new FilterCheckboxes(blockEl, rootClass));
})();

// Filter Properties
(() => {
    const rootClass = 'ed-property-archive';
    const blockEls = document.querySelectorAll(`.${rootClass}`);
    blockEls.forEach((blockEl) => new FilterArchive(blockEl, rootClass));
})();

// Filter Careers
(() => {
    const rootClass = 'careers-archive';
    const blockEls = document.querySelectorAll(`.${rootClass}`);
    blockEls.forEach((blockEl) => new FilterArchive(blockEl, rootClass));
})();

// Search toggle on mobile
(() => {
	const searchEl = document.getElementById('toggle-mobile-search');
    if (searchEl instanceof window.HTMLElement) {
        new Search(searchEl);
    }
})();

// Statistics
(() => {
    const selector = 'statistics-block__animation-enabled';
    const blockEls = document.querySelectorAll(`.${selector}`);
    blockEls.forEach((blockEl) => new EdIntersectionObserver(blockEl, 'statistics-block'));
})();

// Property Banner
(() => {
    const selector = 'hero-banner__property-banner';
    const blockEls = document.querySelectorAll(`.${selector}`);
    blockEls.forEach((blockEl) => new EdIntersectionObserver(blockEl, selector));
})();

// Careers Filter
(() => {
    const selector = 'career-primary-filter-button';
    const blockEls = document.querySelectorAll(`.${selector}`);
    blockEls.forEach((blockEl) => new EdIntersectionObserver(blockEl, selector));
})();


// Ed modal
(() => {
	const rootClass = 'ed-modal-container';
	const blockEls = document.querySelectorAll(`.${rootClass}`);
	blockEls.forEach((blockEl) => new EdModal(blockEl, rootClass));
})();

// Lazy Load Video
(() => {
	const rootClass = 'hero-banner';
	const blockEls = document.querySelectorAll(`.${rootClass}`);
	blockEls.forEach((blockEl) => new LLVideo(blockEl, rootClass));
})();

// Anchor navigation
(async (rootClass) => {
	// Get root elements
	const rootEls = Array.from(document.querySelectorAll(`.${rootClass}`));
	if(0 === rootEls.length) {
		return;
	}

	// Load the module
	const module = await import('./modules/anchor-links.js');

	// Init a handler for each root element
	rootEls.forEach(rootEl => {
		new module.AnchorLinks(rootEl, rootClass);
	});
})('anchor-navigation');

// Grid Filters
(async () => {
	// Classes we care about
	const rootClasses = [
		'news-grid',
		'story-grid',
		'podcast-grid',
	];

	// Make sure at least one element can be found
	const testEl = document.querySelector(`.${rootClasses.join(', .')}`);
	if(!(testEl instanceof window.HTMLElement))
	{
		return;
	}

	// Load the module
	const module = await import('./modules/grid-filters.js');

	// For each root class
	rootClasses.forEach(rootClass => {
		// Find root elements
		const rootEls = document.querySelectorAll(`.${rootClass}`);

		// Init a handler for each root element
		rootEls.forEach(rootEl => {
			new module.GridFilters(rootEl, rootClass);
		});
	});
})();


// Filter modal
(() => {
	const rootClass = 'careers-archive';
	const blockEls = document.querySelectorAll(`.${rootClass}`);
    const controlClass = 'career-filter-menu-active';
	blockEls.forEach((blockEl) => new FilterModal(blockEl, controlClass));
})();

// Video modal
(() => {
    const selector = 'video-modal-block ';
    const blockEls = document.querySelectorAll(`.${selector}`);
    blockEls.forEach((blockEl) => new VideoModal(blockEl));
})();

// Video player
(() => {
    const selector = 'wp-block-video';
    const blockEls = document.querySelectorAll(`.${selector}`);
    blockEls.forEach((blockEl) => new VideoPlayer(blockEl));
})();

// Agents
(() => {
    const selector = 'property-agents';
    const blockEls = document.querySelectorAll(`.${selector}`);
    blockEls.forEach((blockEl) => new Agents(blockEl));
})();